import React from 'react';
import { useInfoValue, CompanyNames } from '../Contexts/InfoContext';

export function ParentCompanyInfo(props) {
	const { data } = useInfoValue();

	return (
		<table cellPadding="0" cellSpacing="0">
			<tbody>
				<tr>
					<td>
						<table cellPadding="0" cellSpacing="0">
							<tbody>
								<tr>
									<td style={{ display: 'block', width: '99.9', clear: 'both' }} height="10px">
										<div>&nbsp;</div>
									</td>
								</tr>
							</tbody>
						</table>

						<table
							cellPadding="0"
							cellSpacing="0"
							style={{ verticalAlign: '-webkit-baseline-middle', fontSize: 'medium', marginLeft: '7px' }}
						>
							<tbody>
								<tr>
									<td style={{ padding: '0' }}>
										<table
											cellPadding="0"
											cellSpacing="0"
											style={{
												verticalAlign: 'top',
												fontSize: 'medium',
												fontFamily: 'Helvetica, Arial, sans-serif',
												width: '100%',
												textAlign: 'right'
											}}
										>
											<tbody>
												<tr>
													<td
														width="35"
														align="left"
														style={{ textAlign: 'left', verticalAlign: 'top' }}
													>
														<a href="https://thegoldenstatecompany.com/">
															<img
																width="35"
																src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/logo-tgsc.png"
																role="presentation"
																style={{ maxWidth: '35px', display: 'block' }}
																alt="gsco logo"
															/>
														</a>
													</td>
													<td width="5">
														<div>&nbsp;</div>
													</td>
												</tr>
											</tbody>
										</table>
									</td>
									<td>
										<table
											cellPadding="0"
											cellSpacing="0"
											style={{
												verticalAlign: 'top',
												fontFamily: 'Helvetica, Arial, sans-serif',
												display: 'inline-block',
												textAlign: 'right'
											}}
										>
											<tbody>
												<tr style={{ textAlign: 'right' }}>
													<td
														align="right"
														style={{
															padding: '0',
															textAlign: 'left',
															font: 'bold',
															lineHeight: '14px',
															color: '#808080',
															fontSize: '10px'
														}}
													>
														<span style={{ whiteSpace: 'nowrap' }}>
															{props.text} is a wholly-owned subsidiary of
														</span>
														<br />
														The Golden State Company
													</td>
												</tr>
											</tbody>
										</table>
									</td>
								</tr>
							</tbody>
						</table>
					</td>
				</tr>
			</tbody>
		</table>
	);
}
